import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";


@Component({
  selector: 'app-report-view',
  templateUrl: './report-preview.component.html',
  styleUrls: ['./report-preview.component.sass'],
})
export class ReportPreviewComponent {
  pdfSafeUrl: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { blob: Blob, fileName: string },
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<ReportPreviewComponent>
  ) {
    const url = URL.createObjectURL(data.blob);
    this.pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  downloadPdf() {
    const url = URL.createObjectURL(this.data.blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = this.data.fileName;
    a.click();
    URL.revokeObjectURL(url);
  }

  close() {
    this.dialogRef.close();
  }
}